<template lang="pug">

    .app-video(:class="{active: active}")

        .app-video__width-ref

        .app-video__wrap(:style="{width: `${vW}px`, height: `${vH}px`, marginLeft: `${-dX}px`, marginTop: `${-dY}px`, backgroundImage: hasPoster ? `url('${base}${poster}')` : 'none'}")

            video(v-if="hasSrc", :src="`${base}${object.src}`", :width="w", :height="h", :autoplay="active", playsinline, muted, loop)

</template>

<script>
/* eslint-disable no-console */
// import {mapGetters} from 'vuex';

const _defaultResize = 'width';
const _getRect = (resize = 'cover', w0 = 640, h0 = 480, w, h) => {
    const sW = w / w0;
    const sH = h / h0;
    let s = Math.min(sW, sH);

    if (resize === 'cover') s = Math.max(sW, sH);
    if (resize === 'width') s = sW;

    const vW = Math.floor(s * w0);
    const vH = Math.floor(s * h0);

    return {
        vW: vW,
        vH: vH,
        dX: resize === 'width' ? 0 : Math.floor((vW - w) / 2),
        dY: resize === 'width' ? 0 : Math.floor((vH - h) / 2)
    };
};

const rect0 = _getRect();

export default {
    name: 'app-video',

    props: {
        base: {
            default: '',
            type: String
        },
        resize: {
            default: _defaultResize,
            type: String
        },
        object: {
            default: null,
            type: Object
        },
        active: {
            default: false,
            type: Boolean
        }
    },

    data() {
        return {
            initiated: false,

            vW: rect0.vW,
            vH: rect0.vH,
            dX: rect0.dX,
            dY: rect0.dY,

            // Size mode:
            // - 0 - desktop
            // - 1 - mobile
            mode: 0,

            //
            lastSavedProgress: 0,
            progressStep: 25
        };
    },

    computed: {
        hasPoster() {
            return this.poster && this.poster.length > 0;
        },

        poster() {
            if (!this.object) return '';
            return this.object.poster || '';
        },

        w() {
            if (!this.hasSrc || !this.sourcesCompact) return 640;
            return this.sourcesCompact.width || 640;
        },

        h() {
            if (!this.hasSrc || !this.sourcesCompact) return 480;
            return this.sourcesCompact.height || 480;
        },

        hasVideo() {
            return this.initiated && this.hasSrc;
        },

        sourcesCompact() {
            if (!this.hasSrc) return null;
            if (!this.object.srcCompact) return this.object.src;
            return this.object.srcCompact;
        },

        hasSrc() {
            return this.object && this.object.src;
        }
    },

    mounted() {},

    watch: {
        active(to) {
            if (to) {
                this.init();
                window.requestAnimationFrame(() => {
                    this.playVideo();
                });
                return;
            }

            this.pauseVideo();
        }
    },

    beforeDestroy() {
        this.stopVideo();
        this.destroyVideo();
    },

    methods: {
        init() {
            if (this.initiated) return;

            this.initiated = true;
            this._$wRef = this.$el.querySelector('.app-video__width-ref');
            this._$video = this.$el.querySelector('video');

            this.handleResize();
            window.addEventListener('resize', this.handleResize);

            // TweenLite.delayedCall(0.1, this.activate, [], this);
        },

        playVideo() {
            if (!this.initiated || !this.hasSrc) return;
            this._$video.play();
        },

        pauseVideo() {
            if (!this.initiated || !this.hasSrc) return;
            this._$video.pause();
        },

        stopVideo() {
            if (!this.initiated || !this.hasSrc) return;
            this._$video.pause();
        },

        destroyVideo() {
            if (!this.initiated) return;

            this.initiated = false;
            window.removeEventListener('resize', this.handleResize);
        }
    }
};
</script>

<style lang="scss" scoped>
//
@import '../assets/css/vars';
//
.app-video {
    position: relative;
    width: 100%;
    overflow: hidden;

    &__wrap {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        line-height: 0;
        font-size: 0;
    }

    video {
        display: block;
        width: 100%;
    }
}
</style>
